import React from 'react'

import { SIZES } from '~/common/globalStyles'
import Loader from '~/views/components/ui/Loader'

import Button, { Props as ButtonProps } from './Button'

export interface Props extends ButtonProps {
  buttonText: string
  loading: boolean
  loadingText?: string
  displayContainer?: string
}

const LoadingButton = ({
  buttonText,
  children,
  disabled,
  loading,
  loadingText,
  displayContainer = 'contents',
  large = true,
  raised = true,
  ...props
}: Props) => (
  <div style={{ position: 'relative', display: displayContainer }}>
    <Button
      large={large}
      raised={raised}
      disabled={loading || disabled}
      {...props}
    >
      {loading && loadingText && (
        <span style={{ marginRight: SIZES.xxs }}>{loadingText}</span>
      )}
      {loading && <Loader />}
      {!loading && (buttonText || children)}
    </Button>
  </div>
)

LoadingButton.defaultProps = {
  buttonText: '',
  loadingText: '',
}

export default LoadingButton
